import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPlainTableBlue = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 17,
	viewBox: "0 0 18 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M1.6875 8.53125H8.15625V4.875H1.6875V8.53125ZM1.6875 10.2188V13.875C1.6875 14.1914 1.93359 14.4375 2.25 14.4375H8.15625V10.2188H1.6875ZM9.84375 14.4375H15.75C16.0312 14.4375 16.3125 14.1914 16.3125 13.875V10.2188H9.84375V14.4375ZM16.3125 8.53125V4.875H9.84375V8.53125H16.3125ZM2.25 0.375H15.75C16.9805 0.375 18 1.39453 18 2.625V13.875C18 15.1406 16.9805 16.125 15.75 16.125H2.25C0.984375 16.125 0 15.1406 0 13.875V2.625C0 1.39453 0.984375 0.375 2.25 0.375Z",
		fill: "#38539A"
	})]
});
const ForwardRef = forwardRef(SvgIconPlainTableBlue);
export { ForwardRef as ReactComponent };
